const root = '/export';

export default {
  root,
} as const;
